import { create } from 'zustand';

const useCaptchaSchedule = create((set) => ({
  action: null,
  triggerClear: () => set({ action: 'clear' }),
  triggerInit: () => set({ action: 'init' }),
  resetAction: () => set({ action: null }),
}));

export default useCaptchaSchedule;